module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("List of Buckets")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--info pull-right",
    attrs: {
      "to": ("" + ('/admin/publisher/' +
                        this.$route.params.uuid +
                        '/domain/' +
                        this.$route.params.domId +
                        '/buckets'))
    }
  }, [_c('i', {
    staticClass: "el-icon-plus el-icon-left"
  }), _vm._v("\n                    Create Bucket\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "box-body domain-list"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.buckets
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('div', {
          staticClass: "text-center"
        }, [_c('img', {
          staticClass: "round",
          attrs: {
            "width": "30",
            "height": "30",
            "avatar": ("" + (props.row.name))
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "300",
      "label": "",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": ("" + ('/admin/publisher/' +
                                    props.row.domain.publisher.uuid +
                                    '/domain/' +
                                    _vm.domId +
                                    '/buckets/' +
                                    props.row.id))
          }
        }, [_c('span', {
          staticClass: "domain-name"
        }, [_vm._v(_vm._s(("" + (props.row.name))))])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "buckets"
        }, [_c('ul', {
          staticClass: "bucket-list clearfix"
        }, [(scope.row.product && scope.row.product.length > 0) ? _c('li', [_c('span', {
          staticClass: "el-button el-button--info pull-right"
        }, [_vm._v("\n                                            " + _vm._s(scope.row.product[0].product &&
          scope.row.product[0].product !== undefined ?
          scope.row.product[0].product.name :
          'No Product Associated yet.') + "\n                                        ")])]) : _vm._e(), _vm._v(" "), (scope.row.product && scope.row.product.length < 1) ? _c('li', [_c('span', {
          staticClass: "el-button el-button--info pull-right"
        }, [_vm._v("No product associated yet.")])]) : _vm._e(), _vm._v(" "), (scope.row.snippet_updated_at) ? _c('li', [_c('span', {
          staticClass: "el-button el-button--info pull-right"
        }, [_vm._v(_vm._s(_vm._f("moment")(("" + (scope.row.snippet_updated_at)), 'MMM Do, h:mm:ss a')))])]) : _vm._e(), _vm._v(" "), (!scope.row.snippet_updated_at) ? _c('li', [_c('span', {
          staticClass: "el-button el-button--info pull-right"
        }, [_vm._v("No Module configuration added yet!")])]) : _vm._e(), _vm._v(" "), (scope.row.product && scope.row.product.length > 0) ? _c('li', [_c('span', {
          staticClass: "pull-right",
          staticStyle: {
            "position": "absolute !important",
            "right": "0px !important"
          }
        }, [(
          scope.row.product[0].product &&
          scope.row.product[0].product !== undefined
        ) ? _c('button', {
          class: scope.row.dirty ? 'btn upload animated flash' : 'btn upload',
          style: (scope.row.dirty ?
            'background : rgb(226, 203, 35) !important;' :
            ''),
          on: {
            "click": function($event) {
              return _vm.createJs(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload el-icon--right"
        })]) : _vm._e()])]) : _vm._e()])])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 ||
              scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1 ?
              'Publisher has GPT disableinitialload setup' :
              'Disable/Enable bucket',
            "placement": "top"
          }
        }, [(scope.row.name != 'default') ? _c('el-switch', {
          ref: 'elem' + scope.$index,
          staticClass: "pull-right ht-24",
          attrs: {
            "disabled": scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 ||
              scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1,
            "title": scope.row.features.indexOf('REFRESH_ALL_UNITS_INITIALLY') > -1 ||
              scope.row.features.indexOf('REFRESH_ALL_UNITS_AFTER_BIDS') > -1 ?
              'Publisher has GPT disableinitial setup' :
              ''
          },
          on: {
            "change": function($event) {
              return _vm.confirmAction(
                scope.row.id,
                scope.row.domain.id,
                scope.row.domain.publisher.id,
                scope.$index,
                $event
              )
            }
          },
          model: {
            value: (_vm.test[scope.$index]),
            callback: function($$v) {
              _vm.$set(_vm.test, scope.$index, $$v)
            },
            expression: "test[scope.$index]"
          }
        }) : _vm._e()], 1)]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c88dd15a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/DomainContext.vue
// module id = 721
// module chunks = 2